/* eslint-disable new-cap */
/* eslint-disable no-unused-vars */
/* eslint-disable spaced-comment */
/* eslint-disable no-var */
/* eslint-disable no-console */
/**
 * MobiAudit v6 interface bridge factory class.
 * Requires CallbackRegistry.
 *
 *
 * @class PlatformBridgeFactory
 * @static
 * @author vdimov
 */
import CallbackRegistry from '@researchmetrics/callback-registry'

const platformBridgeFactory = function() {
  // eslint-disable-next-line prefer-const
  let _instance = null
  const _getInstance = function() {
    if (!_instance) {
      var root = null
      if (typeof window !== 'undefined') {
        root = window
      } else {
        root = global
      }

      _instance = {
        webPlatformBridgeAPISuffix: 'WebImplementation',
        create: function(APIObject, APIName, source, preferredPlatform) {
          var platform = 'web'
          var platformBridge = null

          if (preferredPlatform === 'web') {
            platformBridge = new this.platformBridgeWeb(
              APIName + this.webPlatformBridgeAPISuffix,
              source
            )
          } else if (typeof RMAndroidNativeApp === 'object') {
            platform = 'Android'
            platformBridge = new this.platformBridgeAndroid(
              APIName,
              CallbackRegistry
            )
          } else if (typeof RMIOS === 'object') {
            platform = 'iOS'
            platformBridge = new this.platformBridgeIOS(
              APIName,
              CallbackRegistry
            )
          } else {
            platformBridge = new this.platformBridgeWeb(
              APIName + this.webPlatformBridgeAPISuffix,
              source
            )
          }

          this.wirePlatformMethods(APIObject, platformBridge)
          APIObject.platform = platform
          return platformBridge
        },
        platformBridgeIOS: function(APIName, CallbackRegistry) {
          this.APIName = APIName
          this.CallbackRegistry = CallbackRegistry

          this.execute = function(methodName, args) {
            var _this = this
            var _args = Array.prototype.slice.call(args, 0)
            var _originalArgumentsCount = _args.length

            // We are cleaning up 'undefine'-s because they are trasmited as null
            // in the native.  The native then cant diferenciate between null and
            // undefined coming from the js side. Generally undefined is not a valid
            // argument for a javascript method that calls the native
            _args = _args.filter(argument => argument !== undefined)
            const _CallbackRegistry = this.CallbackRegistry
            return new Promise(function(resolve, reject) {
              var handlerExists = !!root.webkit.messageHandlers
                .iOS_Native_Bridge

              if (!handlerExists) {
                var errorMessaage =
                  "iOS js-native bridge has no messageHandler exposed named '" +
                  "iOS_Native_Bridge'"
                reject(new Error(errorMessaage))
                return
              }

              _CallbackRegistry
                .register(_this, function(data) {
                  var parsedData = JSON.parse(data)
                  if (!parsedData.error) {
                    resolve(parsedData.result)
                  } else {
                    reject(parsedData.error)
                  }
                })
                .then(function(callbackId) {
                  var data = {
                    APIName: APIName,
                    methodName: methodName,
                    callbackID: callbackId,
                    arguments: _args,
                    originalArgumentsCount: _originalArgumentsCount
                  }

                  root.webkit.messageHandlers.iOS_Native_Bridge.postMessage(
                    data
                  )
                })
            })
          }
        },

        platformBridgeAndroid: function(APIName, CallbackRegistry) {
          this.APIName = APIName
          this.CallbackRegistry = CallbackRegistry

          this.execute = function(methodName, args) {
            var _this = this
            var _args = args
            const _CallbackRegistry = this.CallbackRegistry
            return new Promise(function(resolve, reject) {
              _CallbackRegistry
                .register(_this, function(status, data) {
                  if (status) {
                    resolve(JSON.parse(data))
                  } else {
                    try {
                      data = JSON.parse(data)
                    } catch (e) {
                      reject(e, data)
                    }
                    reject(data)
                  }
                })
                .then(function(callbackId) {
                  var callArgs = []
                  callArgs.push(callbackId)
                  if (_args.length > 0) {
                    for (var i = 0, size = _args.length; i < size; i++) {
                      if (typeof _args[i] === 'object') {
                        _args[i] = JSON.stringify(_args[i])
                      }
                    }

                    callArgs = callArgs.concat(
                      Array.prototype.slice.call(_args, 0)
                    )
                  }
                  root[_this.APIName][methodName].apply(
                    root[_this.APIName],
                    callArgs
                  )
                })
            })
          }
        },

        platformBridgeWeb: function(APIName, source) {
          this.APIName = APIName
          this.source = source

          this.execute = function(methodName, args) {
            var _this = this
            var _args = args
            return new Promise(function(resolve, reject) {
              var callArgs = []
              callArgs.push(resolve, reject)
              if (_args.length > 0) {
                callArgs = callArgs.concat(Array.prototype.slice.call(_args, 0))
              }
              _this.source[methodName].apply(_this.source, callArgs)
            })
          }
        },

        wirePlatformMethods: function(APIObject, platformBridge) {
          var propNames = Object.keys(APIObject)
          for (var prop in propNames) {
            var propName = propNames[prop]

            APIObject[propName] = (function(pn) {
              return function() {
                return platformBridge.execute(pn, arguments)
              }
            })(propName)
          }
        }
      }
    }
    return _instance
  }

  return _getInstance()
}

export default new platformBridgeFactory()
